/**
 * SmartThings' webview ignores target="_blank" and window.open, but a
 * same-window navigation works (the Samsung login uses it). Open drtail.us
 * pages in place; the SmartThings back button returns here.
 */
export const openInPlace = (url: string) => {
  window.location.href = url
}
